<template>
  <div class="contragents-row">
    <i-table
      :show-header="false"
      :columns="columns"
      :data="row.contragents"
      no-data-text="Подрядчики отсутствуют"
    />
  </div>
</template>

<script>
import ContragentsRoadmaps from './ contragents-roadmaps'
import { getFormattedCosts, round } from '@/utils'

const columns = [
  {
    type: 'expand',
    width: 50,
    render: (h, params) => {
      return h(ContragentsRoadmaps, {
        props: {
          roadmaps: params.row.roadmaps
        }
      })
    }
  },
  {
    title: 'Подрядчик',
    key: 'performer_name'
  },
  {
    title: 'Стоимость по договору, руб',
    key: 'costs',
    width: 161,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs, true))
    }
  },
  {
    title: 'Информация о подписанных актах',
    key: 'sign_acts',
    width: 160
  },
  {
    title: 'Сумма поступившей оплаты (в т.ч. аванс), руб',
    key: 'payments_value',
    width: 192,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.payments_value, true))
    }
  },
  {
    title: 'Процент поступившей оплаты, %',
    key: 'payment_part',
    width: 128,
    render: (h, params) => {
      return h('span', round(params.row.payment_part * 100, 1))
    }
  }
]

export default {
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      columns
    }
  }
}
</script>

<style>
</style>
